import React from 'react';
import './Toggle.scss';

type Props = {
  values: {
    value: string | number;
    label: string;
  }[];
  value: string;
  onClick: (value: string | number) => void;
};

export const Toggle = ({ values, value, onClick }: Props) => {
  const selectedValueIndex = values.findIndex(v => v.value === value);
  return (
    <div className="toggle">
      {values.map(v => (
        <label
          key={v.value}
          style={
            value === v.value
              ? {
                  color: 'white',
                  width: `${100 / values.length}%`,
                }
              : {
                  width: `${100 / values.length}%`,
                }
          }
        >
          <span>{v.label}</span>
          <input
            type="radio"
            checked={value === v.value}
            onChange={() => onClick(v.value)}
          />
        </label>
      ))}
      <div
        className="toggle__selected"
        style={{
          width: `${100 / values.length}%`,
          left:
            selectedValueIndex === 0
              ? '2px'
              : `calc(${(100 / values.length) * selectedValueIndex}% - 2px)`,
        }}
      />
    </div>
  );
};
